export default function nl2br(text) {
    if (text == null) {
        return '';
    }

    return text.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2');
}